//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true,
      "default": function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      hoverViewsSpec: this.spec.hoverViews ? {
        childViews: this.spec.hoverViews,
        align: this.spec.align
      } : false
    };
  }
};